import { useMutation } from "@tanstack/react-query";
import { API_COUPON } from "../apis";
import { CouponResponse } from "../apis/types/couponResponse";

export const usePostCouponCheck = () => {
    const { mutate } = useMutation<any, Error, any>({
        mutationFn: (params) => API_COUPON.getCoupon<CouponResponse>(params),
    });

    return { mutate };
};
